module.exports = __webpack_public_path__ + "img/shate.958eda4c.png";